<template>
    <el-dialog title="办理信息" :visible.sync="dialogFormVisible">
        <div class="fieldFormWrap" v-if="requireFieldOption.length">
            <template v-for="(item, index) in requireFieldOption">
                <!-- 普通文本输入框 -->
                <div class="contactItem" v-if="item.input_type == 'text'" :key="index">
                    <div class="wrapLabel"><text v-if="item.is_required" class="labelStart">*</text> {{ item.label }}：
                    </div>
                    <div class="enterWrap ">
                        <el-input type="text" @input="changeInputs($event, item)" placeholder-class="custom-placeholder"
                            :maxlength="item.max || ''"
                            :placeholder="item.fill_Requirements ? item.fill_Requirements : '请填写' + item.label"
                            :class="item.checkStatus === false ? 'isError' : ''" :value="item.form_value"
                            show-word-limit></el-input>

                        <!-- 提示信息 如果有的话-->
                        <div class="pickerTips" v-if="item.instruction">{{ item.instruction }}</div>
                        <!-- 异常信息 如果异常的话 -->
                        <div class="errorInfo" v-if="!item.checkStatus">{{ item.errorInfo }}</div>
                    </div>
                </div>

                <!-- 下拉框 -->
                <div class="contactItem" v-if="item.input_type == 'select'" :key="index">
                    <div class="wrapLabel"><text v-if="item.is_required" class="labelStart">*</text> {{ item.label }}：
                    </div>
                    <div class="enterWrap">

                        <el-select placeholder="请选择" v-model="item.form_value" filterable clearable class="selectWrap"
                            :class="item.checkStatus === false ? 'isError' : ''">
                            <el-option v-for="item in item.data_sources" :key="item.value" :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>

                        <!-- 提示信息 如果有的话-->
                        <div class="pickerTips" v-if="item.instruction">{{ item.instruction }}</div>
                        <!-- 异常信息 如果异常的话 -->
                        <div class="errorInfo" v-if="!item.checkStatus">{{ item.errorInfo }}</div>
                    </div>
                </div>

                <!-- 日期 -->
                <div class="contactItem" v-if="item.input_type == 'date'" :key="index">
                    <div class="wrapLabel"><text v-if="item.is_required" class="labelStart">*</text> {{ item.label }}：
                    </div>
                    <div class="enterWrap">
                        <!-- 当该项为日期选择，并且为 "指定生效 ： value=4108" 日期 时，最大日期需要设置为已选择内容的值 -->
                        <template v-if="item.value == 4108">
                            <el-date-picker v-model="item.form_value" type="date" placeholder="选择日期"
                                value-format="yyyy-MM-dd" :picker-options="getDatePickerOption(item)">
                            </el-date-picker>
                        </template>

                        <template v-else>
                            <el-date-picker v-model="item.form_value" type="date" placeholder="选择日期"
                                value-format="yyyy-MM-dd" :picker-options="getDatePickerOption(item)">
                            </el-date-picker>
                        </template>

                        <!-- 提示信息 如果有的话-->
                        <div class="pickerTips" v-if="item.instruction">{{ item.instruction }}</div>

                        <!-- 异常信息 如果异常的话 -->
                        <div class="errorInfo" v-if="!item.checkStatus">{{ item.errorInfo }}</div>
                    </div>
                </div>

            </template>
        </div>

        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="formSubmit">确 定</el-button>
        </div>

    </el-dialog>
</template>

<script>
import $orderPro from '@api/orderPro';

export default {
    name: 'editOrderFieldForm',
    props: {

    },
    watch: {

    },
    mounted() {

    },
    data() {
        return {
            order_sn: '',
            dialogFormVisible: false,
            requireFieldOption: [],
            maxTravelDate: '', // 指定生效日期 的 最大值，当该项的value值为 4108时才设置
        };
    },
    methods: {
        // 表单提交
        formSubmit() {
            let _this = this;

            const formSuccessfully = this.checkFormData();
            if (!formSuccessfully) {
                return;
            }

            let updateForm = {
                order_sn: _this.order_sn
            };

            this.requireFieldOption.map((item) => {
                updateForm[item.field_name] = item.form_value;
            });


            $orderPro.updateOrderExtra(updateForm).then((res) => {
                if (res.status == "success") {
                    _this.$message({
                        type: 'success',
                        message: res.message
                    });
                    _this.dialogFormVisible = false;
                    _this.$emit("UpdateFieldForm");
                }
            })
        },
        // 打开弹窗
        openEditForm(order_sn, data, sku_travel_date) {
            this.order_sn = order_sn;
            this.dialogFormVisible = true;
            this.requireFieldOption = data;
            this.maxTravelDate = sku_travel_date || '';
            // sku_travel_date
        },
        // 返回picker的配置内容
        getDatePickerOption(item) {
            let _this = this;
            const maxTravelDate = _this.maxTravelDate ? _this.maxTravelDate : item.max ? item.max : ''; //当datepicker的ID为 4108：指定生效日期时,需要判断 最大出行日期
            const minTravelData = item.min ? item.min : '';
            return {
                disabledDate(time) {
                    const minDate = minTravelData ? new Date(minTravelData).getTime() : '';
                    const maxDate = maxTravelDate ? new Date(maxTravelDate).getTime() : '';
                    const currentDate = time.getTime();

                    return currentDate < minDate || currentDate > maxDate;
                }
            };
        },
        // 父页面调用的获取表单校验值,与表单数据的函数 2025-03-03
        getFormDatas() {
            let _this = this;

            const formSuccessfully = this.checkFormData();

            // 当表单校验未通过时,返回校验失败的状态
            if (!formSuccessfully) {
                return { checkedStatus: false, data: {} };
            }
            let updateForm = {};


            this.requireFieldOption.map((item) => {
                updateForm[item.field_name] = item.form_value;
            });

            // 当表单校验通过时,返回校验通过状态与表单内容
            return { checkedStatus: true, data: updateForm };
        },
        // 校验表单值
        checkFormData() {
            let _this = this;
            let formChecked = true;
            let data = JSON.parse(JSON.stringify(this.requireFieldOption));

            // 	表单值： form_value 默认'',
            //  校验状态： checkStatus 默认true,
            //  异常信息： errorInfo 默认 '',
            //  下拉选择框的label: selectedLabel,
            for (let item in data) {
                data[item].checkStatus = true;

                // 1:当没有表单值时

                if (!(data[item].form_value + "") && data[item].is_required === 1) {

                    data[item].errorInfo = '请填写' + data[item].label;
                    data[item].checkStatus = false;
                    formChecked = false;

                } else {

                    // -----有表单值时-----
                    // 2:判断表单值是否在最小值 - 最大值之内
                    if (data[item].min || data[item].max) {
                        data[item].min = data[item].min ? Number(data[item].min) : '';
                        data[item].max = data[item].max ? Number(data[item].max) : '';

                        const currentValueLength = data[item].form_value.length;

                        if (data[item].min && data[item].max) {
                            if (currentValueLength < data[item].min || currentValueLength > data[item].max) {
                                data[item].errorInfo = currentValueLength < data[item].min ? '字数不能少于' + data[item]
                                    .min +
                                    '位' : data[item].form_value > data[item].max ? '字数不能大于' + data[item].max + '位' :
                                    '字数限制有误';
                                data[item].checkStatus = false;
                                formChecked = false;
                            }
                        } else if (data[item].min && !data[item].max) {
                            if (currentValueLength < data[item].min) {
                                data[item].errorInfo = '字数不能少于' + data[item].min + '位'
                                data[item].checkStatus = false;
                                formChecked = false;
                            }
                        } else if (!data[item].min && data[item].max) {
                            if (currentValueLength > data[item].max) {
                                data[item].errorInfo = '字数不能大于' + data[item].max + '位'
                                data[item].checkStatus = false;
                                formChecked = false;
                            }
                        }
                    } else {
                        // 3:如果有正则校验
                        if (data[item].js_regex) {
                            const regexString = data[item].js_regex;
                            const regex = new RegExp(regexString.slice(1, -1));
                            if (!regex.test(data[item].form_value)) {
                                data[item].errorInfo = data[item].label + '格式错误!';
                                data[item].checkStatus = false;
                                formChecked = false;
                            }
                        }

                    }
                }
            }

            this.requireFieldOption = data;
            return formChecked;
        },
        // inputs修改事件,通过Name值判断是属于那个键值
        changeInputs(value, item) {

            let val = value;
            let item_field_name = item.field_name;
            const inputType = item.input_type;

            // 当该项为普通输入框时,需要在输入时判断 min - max 值
            const minLength = Number(item.min) || 0,
                maxLength = Number(item.max) || 0;


            this.requireFieldOption.map((item) => {
                if (item.field_name === item_field_name) {
                    item.form_value = val;

                    if (!item.formChecked) {
                        item.checkStatus = '';
                        item.errorInfo = '';
                    }
                }
            });
        },
        // 选择下拉框时
        changeFieldPicker(e, item) {
            let _this = this;
            const selectedIndex = e.detail.value;
            const currentFieldName = item.field_name;

            let targetItem = _this.requireFieldOption.find((item) => item.field_name == currentFieldName);
            const data_sources = targetItem.data_sources;
            const selectedTags = data_sources[selectedIndex];

            const fullValue = selectedTags.value;
            const fullLabel = selectedTags.label;

            _this.requireFieldOption.map((item) => {

                if (item.field_name == currentFieldName) {
                    if (!item.formChecked) {
                        item.checkStatus = '';
                        item.errorInfo = '';
                    }
                    item.form_value = fullValue;
                    item.selectedLabel = fullLabel;
                }
            });
        },
        // 选择日期选择框时
        changeDatePicker(e, item) {

            let _this = this;
            const selectedValue = e.detail.value;
            const currentFieldName = item.field_name;
            _this.requireFieldOption.map((item) => {
                if (item.field_name == currentFieldName) {
                    if (!item.formChecked) {
                        item.checkStatus = '';
                        item.errorInfo = '';
                    }
                    item.form_value = selectedValue;
                }
            });
        },
    }
};
</script>

<style scoped src="./index.css"></style>


<style>
.custom-placeholder {
    color: #3c3c3c;
    font-size: 28rpx;
}
</style>